"use client";

import { c as _c } from "react/compiler-runtime";
import { HeyflowFormView } from "./HeyflowFormView";
interface Props {
  formId: string;
  anchorTag?: string;
  entryId?: string;
}
export default function HeyflowFormClient(t0) {
  const $ = _c(4);
  const {
    formId,
    anchorTag,
    entryId
  } = t0;
  let t1;
  if ($[0] !== anchorTag || $[1] !== entryId || $[2] !== formId) {
    t1 = <HeyflowFormView formId={formId} anchorTag={anchorTag} entryId={entryId} />;
    $[0] = anchorTag;
    $[1] = entryId;
    $[2] = formId;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}